import { BcaRequestStatus } from '@anytag/graphql';
import { TFunction } from 'i18next';
import { BadgeProps } from '@anyui/core';
import { BrandContentPermissionsType } from './schema-types';

export const getBrandContentPermissionsStatusInfo = (t: TFunction, status: BcaRequestStatus | null): BadgeProps => {
  switch (status) {
    case BcaRequestStatus.APPROVED:
      return { children: t('Option.Approved'), color: 'green' };
    case BcaRequestStatus.REQUESTED:
      return { children: t('Option.Requested'), color: 'purple' };
    case BcaRequestStatus.REVOKED:
      return { children: t('Option.Rejected'), color: 'zinc' };
    default:
      return { children: null, color: 'zinc' };
  }
};

export const EMPTY_BRAND_CONTENT_FIELD: BrandContentPermissionsType = {
  instagram_account_id: '',
  instagram_account_name: '',
  brand_id: '',
  status: null,
  isResendable: null,
  disabled: false
};
